export const COMMENT_MAX_LENGTH = 254;
